import React, { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { formatMoneda } from "../../../util/varios";
import axios from "axios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";

export default function Barra() {
  const idFiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const token = localStorage.getItem("jwtToken");
  const op = require("../../../modulos/datos");
  const [dataBarra, setDataBarra] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const buscarRegistros = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/comprasAlmacen/mesesCompras?idFiscal=${idFiscal}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setDataBarra(response.data);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar los Registros de las Graficas",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    buscarRegistros();
  }, [idFiscal]);
  return (
    <div className="">
      <div className="my-1 border-table">
        <ResponsiveContainer width="100%" height="200">
          <BarChart responsive data={dataBarra}>
            <Tooltip
              formatter={(value) =>
                formatMoneda(value.toString().replace(".", ","), ",", ".", 2)
              }
            />
            <Bar
              dataKey="monto"
              fill="#3d8bfd"
              activeBar={{ fill: "#2563eb", stroke: "#2563eb" }}
              radius={[4, 4, 0, 0]}
            />

            <CartesianGrid stroke="#ccc" />
            <XAxis dataKey="mes" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <Dimmer active={loading} inverted />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
    </div>
  );
}
